import { Link } from "react-router-dom";
import { useLang } from "@/lib/i18n";
import { Seo } from "@/components/Seo";
import { OrderButton } from "@/components/TrackedLinks";

export default function NotFoundPage() {
  const { t } = useLang();
  return (
    <div className="py-32 px-4 text-center" data-testid="not-found-page">
      <Seo title="Page Not Found | Tijuas Tacos Birrieria" description="This page does not exist." path="/404" />
      <h1 className="font-serif text-5xl text-hacienda-charcoal font-semibold mb-4">{t("notFound.title")}</h1>
      <p className="text-hacienda-gray text-lg mb-8">{t("notFound.copy")}</p>
      <div className="flex flex-col sm:flex-row gap-4 justify-center">
        <OrderButton location="404" />
        <Link to="/" className="inline-flex items-center justify-center rounded-full border-2 border-hacienda-terracotta text-hacienda-terracotta hover:bg-hacienda-terracotta hover:text-white px-7 py-3 font-medium transition-colors">{t("actions.back")}</Link>
      </div>
    </div>
  );
}
